import React from "react"
import { useTranslation } from "react-i18next"
import { CSSTransition } from "react-transition-group"

import { useAppData, useStaticLink } from "~/api/globals"
import { Title } from "~/components/Helpers/Title/Title"
import { useExportMagLang } from "~/components/LanguageProvider/LanguageProvider"
import { RouterLink } from "~/components/RouterLink/RouterLink"

import { MenuLink } from "../../../MenuLink/MenuLink"
import styles from "./index.module.css"

export const About = ({ isOpen }) => {
  const { links } = useAppData()
  const { i18n } = useTranslation()
  const { exportMagLang } = useExportMagLang()
  const currLang = exportMagLang ? exportMagLang : i18n.language

  return (
    <div className={styles.Wrapper}>
      <CSSTransition
        classNames={{
          enter: styles.Enter,
          enterDone: styles.EnterDone,
          exit: styles.Exit,
        }}
        in={isOpen}
        timeout={{ enter: 100, exit: 220 }}
        unmountOnExit
      >
        <div>
          <MenuLink href={links.services.href}>
            <span>{links.services.title[currLang]}</span>
          </MenuLink>
          {currLang !== "en" && (
            <MenuLink className={styles.TwoLineLink} href={links.process.href}>
              <span>{links.process.title[currLang]}</span>
            </MenuLink>
          )}
          <MenuLink href={links.about.href}>
            <span>{links.about.title[currLang]}</span>
          </MenuLink>
          <MenuLink href={links.awards.href} rel="noopener noreferrer" target="_blank">
            <span>{links.awards.title[currLang]}</span>
          </MenuLink>
        </div>
      </CSSTransition>

      <>
        <CSSTransition
          classNames={{
            enter: styles.Enter,
            enterDone: styles.EnterDone,
            exit: styles.Exit,
          }}
          in={isOpen}
          timeout={{ enter: 170, exit: 220 }}
          unmountOnExit
        >
          <div>
            {currLang === "ru" && (
              <div>
                <MenuLink href={links.blog.href}>
                  <span>{links.blog.title[currLang]}</span>
                </MenuLink>
                <ContextBlog />
              </div>
            )}
          </div>
        </CSSTransition>

        <CSSTransition
          classNames={{
            enter: styles.Enter,
            enterDone: styles.EnterDone,
            exit: styles.Exit,
          }}
          in={isOpen}
          timeout={{ enter: 240, exit: 220 }}
          unmountOnExit
        >
          <div>
            <MenuLink href={links.reviews.href}>
              <span>{links.reviews.title[currLang]}</span>
            </MenuLink>
            <ContextReview />
          </div>
        </CSSTransition>
      </>
    </div>
  )
}

const ContextBlog = () => {
  const context = useAppData()
  const link = useStaticLink("blog")

  if (!context || !context.about) {
    return null
  }

  const { blog } = context.about

  if (!blog[0]) {
    return null
  }

  return (
    <RouterLink
      as={`${link.href}/${blog[0].slug}`}
      className={styles.FeedbackLink}
      href={`/blog/[slug]`}
    >
      <Title type={"h3"} withoutMargin>
        {blog[0].shortTitle}
      </Title>
    </RouterLink>
  )
}

const ContextReview = () => {
  const context = useAppData()
  const link = useStaticLink("reviews")

  if (!context || !context.about) {
    return null
  }

  const { reviews } = context.about
  if (!reviews[0]) {
    return null
  }

  const review = reviews[0]

  return (
    <RouterLink className={styles.FeedbackLink} href={link.href}>
      <div className={styles.FeedbackImage}>
        <img alt={review.author.name} src={review.client.image.LogoTrim} />
      </div>
      <div className={styles.Text} dangerouslySetInnerHTML={{ __html: review.shortText }} />
    </RouterLink>
  )
}
